import { Box } from "@mui/material";
import { NotFoundBlock } from "components/NotFoundBlock";
import { PageTitle } from "components/PageTitle";
import { GetData } from "contexts/DataContext";
import { getFirstInArray, isObjectEmpty, saveMap } from "data/functions";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OrderBlock } from "./OrderBlock";

export function OrdersList(props) {
  const { dataObj } = GetData();

  return (
    <React.Fragment>
      <Box>
        <PageTitle home={false} title="Выбор документа" />
        <Box sx={{ height: "2px" }}>
          {/* {getOrdersVars?.loading && <LinearProgress sx={{ height: "2px" }} />} */}
        </Box>
      </Box>

      <Box
        sx={{
          alignSelf: "center",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          maxWidth: "820px",
          overflow: "auto",
          width: "100%",
        }}
      >
        {isObjectEmpty(dataObj?.searchDocs) && <NotFoundBlock />}
        {!isObjectEmpty(dataObj?.searchDocs) &&
          [...(dataObj?.searchDocs ?? [])].map((order, index) => (
            <OrderBlock
              carID={order?.carID}
              index={index}
              item={order}
              key={index}
            />
          ))}
      </Box>
    </React.Fragment>
  );
}
